import { Component } from '@angular/core';

@Component({
	selector: 'flexus-builders-one',
	template: ` Hello Builders One <button [routerLink]="['/detail']">Go To Two</button> `
})
export class BuildersOneComponent {}
